export const useErrorLogger = () => useState<unknown[]>('sentry-errors', () => []);
